/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Mode_StudentInputs */

const en_messages_mode_student = /** @type {(inputs: Messages_Mode_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const he_messages_mode_student = /** @type {(inputs: Messages_Mode_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמיד`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Messages_Mode_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_mode_student = /** @type {((inputs?: Messages_Mode_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Mode_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_mode_student(inputs)
	return he_messages_mode_student(inputs)
});